import service from "@irati/utils/tracking/index"
import {get} from "lodash"

const tracking = {}

tracking.defaultStatusCode = "200"

tracking.startCreateRecognition = (source: "button" | "textbox" = "button") => {
  service.trackRecognitionEvent("start_create_recognition", {source})
}

tracking.launchRecognition = (poll) => {
  const reward = get(poll, "reward.alt", null)
  const data = {
    statusCode: tracking.defaultStatusCode,
    reward
  }
  service.trackRecognitionEvent("launch_recognition", data)
}

tracking.errorsRecognition = (response) => {
  const statusCode = get(response, "graphQLErrors[0].apiError.response.status", null)
  const data = {statusCode: `${statusCode}`}
  service.trackRecognitionEvent("recognition_error", data)
}

tracking.cancelRecognition = () => {
  service.trackRecognitionEvent("cancel_recognition")
}

tracking.recognitionCtaClick = (data) => {
  const mixpanelData = {
    ...data,
    source: "platform"
  }
  service.trackRecognitionEvent("recognition_cta_click", mixpanelData)
}

export default tracking
